import { render, staticRenderFns } from "./ModalModalApoliceSeguroIBPAdicionar.vue?vue&type=template&id=7976a273"
import script from "./ModalModalApoliceSeguroIBPAdicionar.vue?vue&type=script&lang=js"
export * from "./ModalModalApoliceSeguroIBPAdicionar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports